import { EntityLink } from '../../../Entity'
import { TableDateCell } from '../../../Table'

import * as styles from './DocFlowDateLinkCell.module.css'

function DocFlowDateLinkCell({ link, linkTooltip, ...restProps }) {
  return (
    <TableDateCell {...restProps}>
      <EntityLink className={styles.link} to={link} tooltip={linkTooltip} />
    </TableDateCell>
  )
}

export default DocFlowDateLinkCell
